import { Component, Inject, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';

@Component({
	selector: 'app-modal-terms',
	templateUrl: './modal-terms.component.html',
	styleUrls: ['./modal-terms.component.styl'],
	encapsulation: ViewEncapsulation.None,
})
export class ModalTermsComponent implements OnInit {

	public title: string;
	public text: string;
	public backButtonName = 'Voltar';

	constructor(
		public dialogRef: MatDialogRef<ModalTermsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.title = data.title;
		this.text = data.text;
		this.backButtonName = data.backButtonName ? data.backButtonName : 'Voltar';
	}

	ngOnInit(): void {
	}

	onClose(): void {
		this.dialogRef.close(true);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/modal-terms/modal-terms.component.ts